// extracted by mini-css-extract-plugin
export default {"suggestionsList":"AqCVj_"};